export default __webpack_public_path__ + "static/media/Pending-person.3a11e27e.svg";